import React from "react";
import { DataBox } from "./DataBox";
import { DetailDrawer } from "./DetailDrawer";
import { PageHeader } from "./PageHeader";
import { SyncModal } from "./staffSyncModal";
import { WeChartModal } from "./weChartModal";

export function Card() {
    return (
        <>
            <PageHeader />
            <DataBox />
            <DetailDrawer />
            <WeChartModal />
            <SyncModal />
        </>
    );
}

